
import { PAGES } from "@consts";

export default {
	name: "WordsByLengthCopy",
	props: {
		routeName: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			PAGES,
		};
	},
	computed: {
		alphabetList() {
			let alphabet = "abcdefghijklmnopqrstuvwxyz";
			alphabet = alphabet.split("");

			if (this.$route.name === PAGES.WORDS_BY_LENGTH_LANDING_5_ENDS) {
				return alphabet.filter((letter) => letter !== "j");
			}

			return alphabet;
		},
	},
};
